import { useCallback } from 'react';
import { type GridPath, invalidateGridQuery } from './queryKeys';
import { useInvalidateQueries } from './useInvalidateQueries';

export const useInvalidateGrids = (): ((paths: GridPath[]) => Promise<void>) => {
  const invalidateQueries = useInvalidateQueries();
  return useCallback(
    async (paths: GridPath[]) => {
      await invalidateQueries(paths.map((path) => invalidateGridQuery(path)));
    },
    [invalidateQueries],
  );
};
